import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { useInboxViewport } from '../../hooks/useInboxViewport';

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const inbox = useLocation().pathname === '/app/messages/unified';
  const viewport = useInboxViewport(inbox);

  return (
    <div className={`app-layout ${inbox ? `inbox-layout${viewport.keyboardOpen ? ' inbox-keyboard-open' : ''}` : 'min-h-screen'} bg-gray-50 dark:bg-gray-900`} style={viewport.style}>
      {/* Skip navigation — visible on focus for keyboard users */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-lg focus:text-sm focus:font-medium"
      >
        Skip to main content
      </a>
      <Header onMenuToggle={() => setSidebarOpen(o => !o)} />
      <div className={`flex ${inbox ? 'flex-1 min-h-0' : ''}`}>
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main id="main-content" className={`flex-1 min-w-0 ${inbox ? 'inbox-main flex flex-col min-h-0' : 'p-4 lg:p-8 pb-24 lg:pb-8'}`} tabIndex={-1}>
          <Outlet />
        </main>
      </div>
      <MobileNav />
    </div>
  );
}
